// extracted by mini-css-extract-plugin
export default {"text":"Success_text__YN2NS","slide-in":"Success_slide-in__pExbm"};